import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { UntilDestroy } from '@ngneat/until-destroy'

import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import {
  catchError,
  filter,
  first,
  map,
  switchMap,
  take,
  tap,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { CompetitionTeam } from '../competition-team'
import { competitionTeamActions } from '../competition-team.actions'
import { competitionTeamSelectors } from '../competition-team.selectors'
import { competitionSelectors } from '../../competition.selectors'
import { bookingActions } from '../../../booking/booking.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { competitionActions } from '../../competition.actions'
import { competitionMatchActions } from '../../competition-match/competition-match.actions'
import { Actions, ofType } from '@ngrx/effects'
import { ActivatedRoute } from '@angular/router'
@UntilDestroy()
@Component({
  selector: 'competition-team-planning-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CompetitionTeamPlanningTabComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()

  public teamId$: Observable<number>
  public team$: Observable<CompetitionTeam>

  public form: UntypedFormGroup

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.teamId$ = this.route.paramMap.pipe(
      map((params) => params.get('teamId')),
      map((id) => Number(id)),
      filter((id): id is number => !isNaN(id))
    )

    this.team$ = this.teamId$.pipe(
      tap((id) =>
        this.store.dispatch(competitionTeamActions.fetchOneById({ id }))
      ),
      switchMap((teamId) =>
        this.store.select(competitionTeamSelectors.selectById, teamId)
      )
    )
    this.team$.pipe(first((team) => Boolean(team))).subscribe((team) => {
      if (team && team.competitionId) {
        this.store.dispatch(
          competitionActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: { id: team?.competitionId }
            })
          })
        )
        this.store.dispatch(
          competitionMatchActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: { competitionId: team?.competitionId },
              join: [{ field: 'booking' }]
            })
          })
        )
        this.actions$
          .pipe(
            ofType(competitionActions.upsertMany),
            first(),
            timeout(1000),
            catchError((error) => {
              return of(null)
            })
          )
          .subscribe((action) => {
            this.store
              .select(competitionSelectors.selectEntities)
              .pipe(take(1))
              .subscribe((competition) => {
                if (competition[team?.competitionId]?.linkedChildProductId) {
                  this.store.dispatch(
                    bookingActions.fetchMany({
                      params: RequestQueryBuilder.create({
                        search: {
                          linkedProductId:
                            competition[team?.competitionId]
                              ?.linkedChildProductId
                        },
                        join: [
                          { field: 'saleItems' },
                          { field: 'saleItems.sale' },
                          { field: 'supervisors' },
                          { field: 'product' },
                          { field: 'linkedProduct' }
                        ]
                      })
                    })
                  )
                }
              })
          })
      } else {
        this.store
          .select(competitionSelectors.selectEntities)
          .pipe(take(1))
          .subscribe((competition) => {
            if (competition[team?.competitionId]?.linkedChildProductId) {
              this.store.dispatch(
                bookingActions.fetchMany({
                  params: RequestQueryBuilder.create({
                    search: {
                      linkedProductId:
                        competition[team?.competitionId]?.linkedChildProductId
                    },
                    join: [
                      { field: 'saleItems' },
                      { field: 'saleItems.sale' },
                      { field: 'supervisors' },
                      { field: 'product' },
                      { field: 'linkedProduct' }
                    ]
                  })
                })
              )
            }
          })
      }
    })
  }

  public onBlackListFormSubmit(form: any): void {
    const submitArray = []

    this.team$.pipe(take(1)).subscribe((team) => {
      form?.days.forEach((day) => {
        submitArray.push({
          weekday: day,
          competitionId: team?.competitionId,
          competitionTeamId: team?.id,
          startDate: form.startDate,
          endDate: form.endDate,
          type: 'blacklist'
        })
      })

      this.onSubmit.emit(submitArray)
    })
  }

  public onWhiteListFormSubmit(form: any): void {
    const submitArray = []

    this.team$.pipe(take(1)).subscribe((team) => {
      form?.days.forEach((day) => {
        submitArray.push({
          weekday: day,
          competitionId: team?.competitionId,
          competitionTeamId: team?.id,
          startDate: form.startDate,
          endDate: form.endDate,
          type: 'whitelist'
        })
      })

      this.onSubmit.emit(submitArray)
    })
  }
}
